import app from '@/app';

/* @ngInject */
function stateConfig($stateProvider, stateHelperProvider) {
  var states = [
    {
      name: 'unitPriceTables',
      parent: 'entity',
      url: '/unitPriceTables&name&page&sort',
      component: 'unitPriceTablesSearch',
      data: {
        viewAuthorities: ['COSTTABLE_READ'],
        editAuthorities: ['COSTTABLE_WRITE']
      },
      params: {
        name: { value: null, squash: true, dynamic: true },
        page: { value: 0, type: 'int', squash: true, dynamic: true },
        sort: { value: 'name,asc', squash: true, dynamic: true }
      }
    },
    {
      name: 'unitPriceTables.detail',
      url: '/{id}',
      component: 'unitPriceTablesDetail',
      resolve: {
        /* @ngInject */
        entity: (UnitPriceTable, $transition$, entityInjector) => entityInjector(UnitPriceTable, $transition$.params().id)
      }
    }
  ];
  states.forEach(state => $stateProvider.state(state));
}

app.config(stateConfig);
